module.exports = __webpack_public_path__ + "f279df673f2e3c0d56ab61fee6a6cee0.MP3";